"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTTI_MedicinalProductPackaged_PackageItem = void 0;
var t = __importStar(require("io-ts"));
var RTTI_Extension_1 = require("./RTTI_Extension");
var RTTI_Identifier_1 = require("./RTTI_Identifier");
var RTTI_CodeableConcept_1 = require("./RTTI_CodeableConcept");
var RTTI_Quantity_1 = require("./RTTI_Quantity");
var RTTI_Reference_1 = require("./RTTI_Reference");
var RTTI_ProdCharacteristic_1 = require("./RTTI_ProdCharacteristic");
var RTTI_ProductShelfLife_1 = require("./RTTI_ProductShelfLife");
exports.RTTI_MedicinalProductPackaged_PackageItem = t.recursion('IMedicinalProductPackaged_PackageItem', function () {
    return t.intersection([
        t.type({
            type: RTTI_CodeableConcept_1.RTTI_CodeableConcept,
            quantity: RTTI_Quantity_1.RTTI_Quantity
        }),
        t.partial({
            id: t.string,
            extension: t.array(RTTI_Extension_1.RTTI_Extension),
            modifierExtension: t.array(RTTI_Extension_1.RTTI_Extension),
            identifier: t.array(RTTI_Identifier_1.RTTI_Identifier),
            material: t.array(RTTI_CodeableConcept_1.RTTI_CodeableConcept),
            alternateMaterial: t.array(RTTI_CodeableConcept_1.RTTI_CodeableConcept),
            device: t.array(RTTI_Reference_1.RTTI_Reference),
            manufacturedItem: t.array(RTTI_Reference_1.RTTI_Reference),
            packageItem: t.array(exports.RTTI_MedicinalProductPackaged_PackageItem),
            physicalCharacteristics: RTTI_ProdCharacteristic_1.RTTI_ProdCharacteristic,
            otherCharacteristics: t.array(RTTI_CodeableConcept_1.RTTI_CodeableConcept),
            shelfLifeStorage: t.array(RTTI_ProductShelfLife_1.RTTI_ProductShelfLife),
            manufacturer: t.array(RTTI_Reference_1.RTTI_Reference)
        })
    ]);
});
//# sourceMappingURL=RTTI_MedicinalProductPackaged_PackageItem.js.map